/**
 * @generated SignedSource<<db0e787caa899d86e0d487c4b1052741>>
 * @relayHash 16965e1dd4ba0080e939f15939cf2afb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 16965e1dd4ba0080e939f15939cf2afb

import { ConcreteRequest } from 'relay-runtime';
export type De_cancelQesSigningRequestInput = {
  signingRequestId: string;
};
export type useDeCancelQesSigningMutation$variables = {
  input: De_cancelQesSigningRequestInput;
};
export type useDeCancelQesSigningMutation$data = {
  readonly de_cancelQesSigningRequest: {
    readonly boolean: boolean | null;
  };
};
export type useDeCancelQesSigningMutation = {
  response: useDeCancelQesSigningMutation$data;
  variables: useDeCancelQesSigningMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_cancelQesSigningRequestPayload",
    "kind": "LinkedField",
    "name": "de_cancelQesSigningRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeCancelQesSigningMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeCancelQesSigningMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "16965e1dd4ba0080e939f15939cf2afb",
    "metadata": {},
    "name": "useDeCancelQesSigningMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3dd58f76f3907e525526cac0aac302f6";

export default node;
